"use client";
import { Box, type BoxProps } from "@mui/material";
import { type MotionProps, motion } from "framer-motion";
import type React from "react";

type CustomMotionProps = MotionProps &
	BoxProps & {
		component?: React.ElementType;
		style?: never;
	};

export function Motion({
	component = Box,
	transition,
	viewport,
	...props
}: Readonly<CustomMotionProps>) {
	const Component = motion.create(component);

	return (
		<Component
			whileInView={{ opacity: 1, x: 0, y: 0 }}
			viewport={{ once: true, amount: 0.05, ...viewport }}
			transition={{ duration: 0.5, ease: "easeInOut", ...transition }}
			{...props}
		/>
	);
}
